import { css } from 'lit';

// Semantic surface / text / border layer.
// Components reference THESE (not raw palette/white/gray), so light & dark are a
// single source of truth. Dark overrides live in variables.dark.css.mjs.
// `--color-white`/`--color-black` stay LITERAL (e.g. text on a filled button) —
// use --surface-* for backgrounds and --on-surface-* for text instead.
export default css`
  /* Surfaces (light) */
  --surface-base: var(--color-white);        /* page / app background */
  --surface-raised: var(--color-white);       /* cards, inputs, alerts, menus, tooltips, popups */
  --surface-sunken: var(--color-gray-1);       /* subtle inset rows (lists) */
  --surface-hover: var(--color-gray-2);        /* hovered row/menu item */
  --surface-overlay: rgba(0, 0, 0, 0.5);       /* modal scrim */
  --surface-knob: var(--color-white);          /* toggle/switch knob */

  /* Borders (light) */
  --border-subtle: var(--color-gray-3);
  --border-strong: var(--color-gray-6);

  /* Text on surface (light) */
  --on-surface: var(--color-gray-9);           /* primary text */
  --on-surface-muted: var(--color-gray-6);     /* secondary text / placeholders */
  --on-surface-subtle: var(--color-gray-4);    /* tertiary / disabled-ish */

  /* Re-point the legacy global text token at the semantic one. */
  --base-text-color: var(--on-surface);
`;
